const HOME_DASHBOARD_ROOT_KEY = ["dashboard", "home"] as const

/** Branch-scoped keys for the home dashboard (docs/rules/query-keys.rules.md): workspace AND branch, always. */
export const homeDashboardQueryKeys = {
  root: HOME_DASHBOARD_ROOT_KEY,
  finance: (
    workspaceId: string | null | undefined,
    branchId: string | null | undefined,
    range: { dateFrom: string; dateTo: string },
  ) =>
    [
      ...HOME_DASHBOARD_ROOT_KEY,
      "finance",
      workspaceId ?? "__none__",
      branchId ?? "__none__",
      { dateFrom: range.dateFrom, dateTo: range.dateTo },
    ] as const,
  members: (workspaceId: string | null | undefined, branchId: string | null | undefined) =>
    [...HOME_DASHBOARD_ROOT_KEY, "members", workspaceId ?? "__none__", branchId ?? "__none__"] as const,
}
